import { render } from "./TopScreen.vue?vue&type=template&id=21444f3a&scoped=true&ts=true&lang=pug"
import script from "./TopScreen.vue?vue&type=script&lang=ts"
export * from "./TopScreen.vue?vue&type=script&lang=ts"

import "./TopScreen.vue?vue&type=style&index=0&id=21444f3a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21444f3a"]])

export default __exports__